var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3619 18.0052L20.0371 13.1504L24.7147 18.0078L27.435 15.1828L20.0371 7.5L12.6416 15.1802L15.3619 18.0052Z",
    fill: "#F49300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4405 19.9996L10.7202 17.1747L7.9998 19.9998L10.7201 22.8247L13.4405 19.9996Z",
    fill: "#F49300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3615 21.9949L20.0367 26.8498L24.7141 21.9926L27.4359 24.816L27.4346 24.8175L20.0367 32.5001L12.641 24.8201L12.6372 24.8162L15.3615 21.9949Z",
    fill: "#F49300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3538 22.826L32.0742 20.0009L29.3539 17.176L26.6335 20.0011L29.3538 22.826Z",
    fill: "#F49300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.796 19.9985H22.7971L20.0367 17.1318L17.9967 19.2503H17.9965L17.7622 19.4938L17.2787 19.9959L17.2749 19.9999L17.2787 20.004L20.0367 22.8681L22.7971 20.0015L22.7985 19.9999L22.796 19.9985Z",
    fill: "#F49300"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.09dbae6a2cb8053d886db32e7c78c667.svg";
export { ForwardRef as ReactComponent };